import { styled } from '@linaria/react';

import { ButtonPrimary } from '~shared/ui/atoms/Buttons/ButtonPrimary';
import { MqTablet } from '~theme/media';

export const StyledNextButton = styled(ButtonPrimary)`
	position: fixed;
	z-index: 1;
	bottom: calc(2rem + var(--safe-bottom));
	left: 50%;
	width: 100%;
	max-width: 350px;
	margin-right: auto;
	margin-left: auto;
	transform: translateX(-50%);

	${MqTablet} {
		bottom: calc(4.2rem + var(--safe-bottom));
	}
`;
